var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#461a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5.5a.5.5 0 0 0-1 0V2h-.167A2.333 2.333 0 0 0 0 4.333V9.5A2.5 2.5 0 0 0 2.5 12h7A2.5 2.5 0 0 0 12 9.5V4.333A2.333 2.333 0 0 0 9.667 2H9.5V.5a.5.5 0 0 0-1 0V2h-5zM1 4.333C1 3.597 1.597 3 2.333 3h7.334C10.403 3 11 3.597 11 4.333V9.5A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zM7 6h-.5v2.293l.646-.647a.5.5 0 1 1 .708.708l-1.5 1.5a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708l.646.647V6H5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "461a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgArCreditNotessmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArCreditNotessmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8xNTA1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41IDAuNUMzLjUgMC4yMjM4NTggMy4yNzYxNCAwIDMgMEMyLjcyMzg2IDAgMi41IDAuMjIzODU4IDIuNSAwLjVWMkgyLjMzMzMzQzEuMDQ0NjcgMiAwIDMuMDQ0NjcgMCA0LjMzMzMzVjkuNUMwIDEwLjg4MDcgMS4xMTkyOSAxMiAyLjUgMTJIOS41QzEwLjg4MDcgMTIgMTIgMTAuODgwNyAxMiA5LjVWNC4zMzMzM0MxMiAzLjA0NDY3IDEwLjk1NTMgMiA5LjY2NjY3IDJIOS41VjAuNUM5LjUgMC4yMjM4NTggOS4yNzYxNCAwIDkgMEM4LjcyMzg2IDAgOC41IDAuMjIzODU4IDguNSAwLjVWMkgzLjVWMC41Wk0xIDQuMzMzMzNDMSAzLjU5Njk1IDEuNTk2OTUgMyAyLjMzMzMzIDNIOS42NjY2N0MxMC40MDMgMyAxMSAzLjU5Njk1IDExIDQuMzMzMzNWOS41QzExIDEwLjMyODQgMTAuMzI4NCAxMSA5LjUgMTFIMi41QzEuNjcxNTcgMTEgMSAxMC4zMjg0IDEgOS41VjQuMzMzMzNaTTcgNkg2LjVWOC4yOTI4OUw3LjE0NjQ1IDcuNjQ2NDVDNy4zNDE3MSA3LjQ1MTE4IDcuNjU4MjkgNy40NTExOCA3Ljg1MzU1IDcuNjQ2NDVDOC4wNDg4MiA3Ljg0MTcxIDguMDQ4ODIgOC4xNTgyOSA3Ljg1MzU1IDguMzUzNTVMNi4zNTM1NSA5Ljg1MzU1QzYuMTU4MjkgMTAuMDQ4OCA1Ljg0MTcxIDEwLjA0ODggNS42NDY0NSA5Ljg1MzU1TDQuMTQ2NDUgOC4zNTM1NUMzLjk1MTE4IDguMTU4MjkgMy45NTExOCA3Ljg0MTcxIDQuMTQ2NDUgNy42NDY0NUM0LjM0MTcxIDcuNDUxMTggNC42NTgyOSA3LjQ1MTE4IDQuODUzNTUgNy42NDY0NUw1LjUgOC4yOTI4OVY2SDVDNC43MjM4NiA2IDQuNSA1Ljc3NjE0IDQuNSA1LjVDNC41IDUuMjIzODYgNC43MjM4NiA1IDUgNUg2SDdDNy4yNzYxNCA1IDcuNSA1LjIyMzg2IDcuNSA1LjVDNy41IDUuNzc2MTQgNy4yNzYxNCA2IDcgNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI3MV8xNTA1Ij4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";